export default __webpack_public_path__ + "static/media/hero.70df764c.webm";